import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import TenableVulnerabilityManagementMappingFormV2 from "./TenableVulnerabilityManagementMappingFormV2";
import TenableVulnerabilityManagementCredentialsForm from "./TenableVulnerabilityManagementCredentialsForm";
import ContentOverlay from "components/ContentOverlay";
import { isEmpty, map, split } from "lodash";
import { CellRenderers } from "utils/tableUtils";

export default function TenableVulnerabilityManagementConfigListing(props) {
  const extraColumns = useMemo(
    () => [
      {
        dataIndex: "assetTagKey",
        title: "Asset Tag Key and Value",
        width: 240,
        render: (tagKey, record) => {
          const tagValues = split(record.assetTagValue, ";");
          const renderName = map(split(tagKey, ","), (item, index) =>
            !tagKey
              ? "All"
              : `${item} - [${!tagValues ? "All" : split(tagValues[index], ",").join(", ")}]`,
          );

          const content = renderName.map((item, i) => <p key={i}>{item}</p>);

          return <ContentOverlay content={content} minHeight={40} />;
        },
      },
      {
        dataIndex: "ingestionType",
        title: "Ingestion Type",
        width: 150,
        render: (value) => {
          // If value is null/undefined, it's legacy data. Show "Vulnerabilities".
          if (!value) return "Vulnerabilities";
          // If value is "All" or a comma-separated string, show it as is.
          return value;
        },
      },
      {
        dataIndex: "hostAuditResult",
        title: "Host Audit Result",
        width: 150,
        render: (value, record) => {
          // If Host Audit is not part of the ingestionType, don't show a result column value
          const ingestionType = record.ingestionType || "Vulnerabilities";
          if (ingestionType !== "All" && !ingestionType.includes("Host Audit")) {
            return CellRenderers.VALUE_OR_NA();
          }
          // If it is Host Audit but value is empty/null, it means "All" results are included
          return !value || value === "All" ? "All" : value;
        },
      },
    ],
    []
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={TenableVulnerabilityManagementMappingFormV2}
      triggerModifyParam={triggerModifyParam}
      CredentialsForm={TenableVulnerabilityManagementCredentialsForm}
      displayComponentName="Asset Tag"
      extraColumns={extraColumns}
    />
  );
}

const triggerModifyParam = (record) => {
  return {
    toolConfigId: record.id,
  };
};
